import React from 'react';
import { motion } from 'framer-motion';
import {
  Sparkles, Footprints, Shield, Award, Target, Crosshair,
  Coins, Gem, Bird, Crown, Flame, Lock, Trophy
} from 'lucide-react';

const ICONS = {
  Sparkles, Footprints, Shield, Award, Target, Crosshair,
  Coins, Gem, Bird, Crown, Flame, Trophy
};

const TIER_STYLES = {
  bronze: 'from-amber-700/30 to-amber-900/10 border-amber-600/40 text-amber-400',
  silver: 'from-slate-400/25 to-slate-600/10 border-slate-300/40 text-slate-200',
  gold: 'from-yellow-500/30 to-amber-500/10 border-yellow-400/50 text-yellow-300',
};

export const AchievementBadge = ({ achievement, unlocked = true, animate = false }) => {
  const Icon = ICONS[achievement.icon] || Trophy;
  const tier = TIER_STYLES[achievement.tier] || TIER_STYLES.bronze;

  return (
    <motion.div
      data-testid={`achievement-badge-${achievement.id}`}
      initial={animate ? { opacity: 0, scale: 0.8 } : false}
      animate={animate ? { opacity: 1, scale: 1 } : false}
      className={`relative flex flex-col items-center text-center p-3 rounded-xl border bg-gradient-to-b transition-all ${
        unlocked ? tier : 'from-muted/30 to-muted/5 border-border text-muted-foreground opacity-50'
      }`}
    >
      <div className={`mb-2 rounded-full p-2 ${unlocked ? 'bg-black/20' : 'bg-muted/40'}`}>
        {unlocked ? <Icon className="w-6 h-6" /> : <Lock className="w-6 h-6" />}
      </div>
      <div className="text-sm font-heading font-semibold leading-tight text-foreground">
        {achievement.name}
      </div>
      <div className="text-[11px] text-muted-foreground mt-1 leading-tight">
        {achievement.description}
      </div>
    </motion.div>
  );
};

export default AchievementBadge;
